export default __webpack_public_path__ + "static/media/butterflies.172b9f9e.png";